import { HiddenFromItineraryPill } from "components/Pill/HiddenFromItineraryPill";
import { HiddenFromMobileApp } from "components/Pill/HiddenFromMobileApp";
import SmallDetails from "components/SmallDetails/SmallDetails";
import React from "react";
import { getFormElementType } from "utilities/freefieldUtils";
import { routes } from "utilities/routing/generatedRoutes";

interface FreeFieldRowProps {
  freeField: server.dto.FreeFieldDefinitionSmall
}

export const FreeFieldRow = (props: FreeFieldRowProps) => {
  return <>
    <div style={{ flex: 1 }}>
      <SmallDetails
        label={props.freeField.title}
        link={routes.freeFieldDefinition_Detail(props.freeField.freeFieldDefinitionId).absolute}
        subLabel={props.freeField.description}
      />
    </div>
    <div style={{ flex: 1 }}>
      <SmallDetails
        label={getFormElementType(props.freeField.type).text}
        subLabel={props.freeField.reference}
      />
    </div>
    <div style={{ flex: 1 }} className="flex-column gap-small">
      {props.freeField.hideFromItinerary && <div><HiddenFromItineraryPill /></div>}
      {props.freeField.hideFromMobileApp && <div><HiddenFromMobileApp /></div>}
    </div>
  </>
}